export default "__VITE_ASSET__D0TMSJmN__"